// save data to local storage
import AsyncStorage from '@react-native-async-storage/async-storage';

const storeData = async (key, value) => {
  AsyncStorage.setItem(key, value);
}

const storeObject = async (key, value) => {
  AsyncStorage.setItem(key, JSON.stringify(value));
}

const getData = async (key) => {
  return AsyncStorage.getItem(key);
}

const getObject = async (key) => {
  return AsyncStorage.getItem(key).then((value) => {
    return JSON.parse(value);
  });
}

const toggleListElement = async (key, value) => {
    let list = await getObject(key);
    if(list === null) {
        list = [];
    }
    if(list.includes(value)) {
        list = list.filter((element) => {
        return element !== value;
        });
    } else {
        list.push(value);
    }
    await storeObject(key, list);
    return list;
}

const listContains = async (key, value) => {
    let list = await getObject(key);
    if(list === null) {
        return false;
    }
    return list.includes(value);
}

export {storeData, storeObject, getData, getObject, toggleListElement, listContains};
